"use client";

import { useEffect, useState } from "react";
import Button from "@components/atoms/Button";
import styles from "../VariantCard.module.scss";
import { addCaptureIntentIfNeeded, getLoginUrl } from "@utils/getLoginUrl";
import { maskAmount } from "@utils/numberFormatter";
import { useGlobalLoader } from "@hooks/useGlobalLoader";

type Props = {
  brandName?: string;
  modelName?: string;
  title?: string;
  savings?: any;
  pageType?: any;
  location?: string;
  carAvailability?: string;
  variantSlug?: string;
};

export default function ButtonClientWrapper({
  brandName,
  modelName,
  title,
  savings,
  pageType,
  location,
  carAvailability,
}: Props) {
  const [currentUrl, setCurrentUrl] = useState("");
  const { showLoader } = useGlobalLoader();

  const mmvDetails = {
    make: brandName || "",
    model: modelName || "",
    variant: title || "",
    color: "",
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href);
    }
  }, []);

  return (
    <div className={styles.exploreButtonWrapper}>
      <div className={styles.savingLabel}>
        {`Save up to ${maskAmount(savings)}`}
      </div>
      <Button
        size="ds"
        className={styles.exploreLoggedOutButton}
        onButtonClick={() => {
          if (typeof window !== "undefined") {
            sessionStorage.setItem("loginType", "Reveal price");
            localStorage.setItem("MMV", JSON.stringify(mmvDetails));
          }
          showLoader("Loading variant details...");
          window.location.href = getLoginUrl(
            addCaptureIntentIfNeeded(
              currentUrl,
              mmvDetails,
              "Reveal price",
              pageType
            )
          );
        }}
        segmentEventProps={{
          eventName: "action",
          pageType,
          eventProperties: {
            action_type: "tap_btn",
            action_name: "tap_btn_login_to_save",
            section: "Variant",
            variant_name: title,
            car_availability: carAvailability,
            city_name: location,
            vehicle_make: brandName,
            vehicle_model: modelName,
          },
        }}
      >
        Check ACKO Drive price
      </Button>
    </div>
  );
}
